import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-dialog--no-header__content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reactivate Ditto?"),
  /*#__PURE__*/_createTextVNode(" Your trial has expired. However, you can try Ditto again for 30 days.")
], -1)
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = {
  key: 1,
  class: "el-dialog--no-header__content expired"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Oh no!"),
  /*#__PURE__*/_createTextVNode(" Your trial has expired.")
], -1)
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = {
  key: 2,
  class: "el-dialog--no-header__content expired"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "You have not selected a Ditto plan! Go to billing and select a plan!", -1)
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = {
  key: 3,
  class: "el-dialog--no-header__content"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Your subscription is inactive! Go to Billing to start a subscription!", -1)
const _hoisted_12 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.expiredSubscriptionVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expiredSubscriptionVisible) = $event)),
    width: "30%",
    top: "35vh",
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "show-close": false,
    "custom-class": "el-dialog--no-header"
  }, {
    default: _withCtx(() => [
      (_ctx.reactivateTrialVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.reactivateTrial
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Reactivate Trial")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.expiredTrialVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/organization/billing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Go to Billing")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.noTierVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_router_link, { to: "/organization/billing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Go to Billing")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.inactiveSubscriptionVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_router_link, { to: "/organization/billing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "el-button--large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Go to Billing")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}